export default __webpack_public_path__ + "static/us-1-lg-b0ebc9c5f184f1f8db4406d9f2967168.png";